import { useEffect } from 'react'
import { PageContext } from './pages/PageContext'
import { findPage, type PageDefinition } from './pages/registry'
import { siteCanonicalUrl } from './siteDestinations'

type SiteRouterProps = {
  pathname?: string
}

function updateMetaContent(selector: string, attribute: string, value: string, content: string) {
  let element = document.head.querySelector<HTMLMetaElement>(selector)
  if (!element) {
    element = document.createElement('meta')
    element.setAttribute(attribute, value)
    document.head.append(element)
  }
  element.content = content
}

/**
 * No build, o pré-render já grava título, canonical e descrição no HTML de cada
 * página. Este efeito cobre o servidor de desenvolvimento e a navegação sem
 * pré-render, mantendo o <head> coerente com a página exibida.
 */
function useDocumentMetadata(page: PageDefinition) {
  useEffect(() => {
    const canonicalUrl = new URL(page.path, siteCanonicalUrl).href
    let canonical = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]')
    if (!canonical) {
      canonical = document.createElement('link')
      canonical.rel = 'canonical'
      document.head.append(canonical)
    }

    document.title = page.title
    canonical.href = canonicalUrl
    updateMetaContent('meta[name="robots"]', 'name', 'robots', page.robots)
    updateMetaContent('meta[name="description"]', 'name', 'description', page.description)
    updateMetaContent('meta[property="og:url"]', 'property', 'og:url', canonicalUrl)
    updateMetaContent('meta[property="og:title"]', 'property', 'og:title', page.title)
    updateMetaContent('meta[property="og:description"]', 'property', 'og:description', page.description)
  }, [page])
}

export default function SiteRouter({ pathname = window.location.pathname }: SiteRouterProps) {
  const page = findPage(pathname)
  const { Component } = page

  useDocumentMetadata(page)

  return (
    <PageContext.Provider value={{ path: page.path, whatsappMessage: page.whatsappMessage }}>
      <Component />
    </PageContext.Provider>
  )
}
